module.exports = __webpack_public_path__ + "img/model-2.abb541a.png";